'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  notification: {
    meta_title: 'Caligram - Notifications',
    title: 'Notifications',
    empty: 'Aucune notification. Tout est sous contrôle',
    nav: {
      new: 'Nouvelles',
      archived: 'Archivées'
    },
    activity: {
      request: {
        message: '<b>%{sourceName}</b> souhaite publier un nouvel événement dans %{destinationName}.',
        action: {
          title: 'Cette notification exige une action.',
          message: 'Souhaitez-vous tout de même l\'archiver?'
        },
        event: {
          show: 'Voir la fiche complète',
          more_themes: '+%{smart_count} thème |||| +%{smart_count} thèmes',
          more_tags: 'et %{smart_count} autre thème |||| et %{smart_count} autres thèmes',
          to: 'au'
        }
      },
      declined: {
        message: 'Votre événement <b>%{sourceName}</b> a été refusé dans %{destinationName}.',
        entry: {
          item: {
            message: 'Message de %{name}'
          }
        }
      },
      published: {
        message: 'Votre événement <b>%{sourceName}</b> a été publié dans %{destinationName}.'
      },
      button: {
        reject: 'REFUSER',
        publish: 'PUBLIER'
      }
    },
    request_modal: {
      title: 'Rejeter: %{title}',
      input_placeholder: 'Pourquoi rejetez-vous cet événement',
      submit: 'Envoyer',
      submit_empty: 'Envoyer sans message'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/locales/fr/notification.js
// module id = 2294
// module chunks = 0